import req from "../http";

const role = {
  // 取得 角色(分頁)
  getRolePaging(params) {
    return req("get", "/auth/role/paging", params);
  },

  // 取得 角色
  getRole(params) {
    return req("get", "/auth/role", params);
  },

  // 新增 角色
  postRole(params) {
    return req("post", "/auth/role", params);
  },

  // 更新 角色 
  putRole(params, id) {
    return req("put", `/auth/role/${id}`, params);
  },

  // 刪除 角色
  deleteRole(id) {
    return req("delete", `/auth/role/${id}`);
  },

  // 取得 角色人員
  getRoleMember(roleName) {
    return req("get", `/auth/rolemember`,{
      RoleName: roleName
    });
  },

  // 設定 角色人員
  postRoleMember(params) {
    return req("post", "/auth/rolemember", params);
  },

  // 取得 角色權限
  getRoleMenu(roleName) {
    return req("get", `/auth/rolemenu`,{
      RoleName: roleName
    });
  },

  // 設定 角色權限
  postRoleMenu(params) {
    return req("post", "/auth/rolemenu", params);
  },
};

export default role;